import { setup, renderScreens, screen } from './dooh-react-utils';
import preloader from './preload';
import { questions } from './questions';

setup('https://interaktivno.go2digital.hr/').then(async data => {
  const state = {
    screen: 'intro',
    score: 0,
    questions,
  };

  renderScreens(
    [
      screen(require('./screens/Intro').default, 'intro', {}),
      screen(require('./screens/Age').default, 'age', {
        timeout: 12 * 1000,
      }),
      screen(require('./screens/Main').default, 'quiz', {
        timeout: 120 * 1000,
      }),
      screen(require('./screens/Result').default, 'result', {
        timeout: 10 * 1000,
      }),
      screen(require('./screens/Thanks').default, 'thanks', {
        timeout: 7 * 1000,
      }),
    ],
    state,
    s => s.screen,
    preloader
  );
});

const isVideoPlaying = video =>
  !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > 2
  );

setInterval(() => {
  let vid = document.getElementById('vid');
  if (vid && !isVideoPlaying(vid)) {
    vid.play();
  }
}, 1000);
